import { render } from "./Project_Allocations.vue?vue&type=template&id=776c4425"
import script from "./Project_Allocations.vue?vue&type=script&lang=js"
export * from "./Project_Allocations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__